import * as Sentry from '@sentry/react';
import { store } from '../redux/configureStore';
import { incrementUnreadNotificationCounter } from '../redux/actions/unread-notification-counter-action';
import { setNewChatThread } from '../redux/actions/chat-actions';

class WebSocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    if (!this.socket) {
      const url = `${process.env.REACT_APP_WEB_SERVER_PROTOCOL}://${process.env.REACT_APP_SERVER_DOMAIN_NAME}`;
      this.socket = new WebSocket(`${url}/ws/message-listener`);

      this.socket.onmessage = (event) => {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (parseError) {
          Sentry.captureException(parseError, {
            extra: { rawData: event.data },
          });
          return;
        }

        switch (data.type) {
          case 'NEW_NOTIFICATION':
            store.dispatch(incrementUnreadNotificationCounter());
            break;
          case 'NEW_MESSAGE':
            store.dispatch(setNewChatThread(data.thread));
            break;
          default:
            break;
        }
      };

      this.socket.onclose = () => {
        console.log('WebSocket disconnected');
        // Optionally handle reconnection
      };

      this.socket.onerror = (error) => {
        Sentry.captureException(new Error('WebSocket connection error'), {
          extra: { event: error },
        });
      };
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  sendMessage(message) {
    if (this.socket) {
      this.socket.send(JSON.stringify(message));
    }
  }
}

const instance = new WebSocketService();
export default instance;
